import { reduce, size } from "lodash";
import { gradients } from "@glossy";

export enum Language {
  Afrikaans = "af",
  Arabic = "ar",
  Arabizi = "ar-bz",
  Bulgarian = "bg",
  Bengali = "bn",
  Catalan = "ca",
  Czech = "cs",
  Danish = "da",
  German = "de",
  Maldivian = "dv",
  Greek = "el",
  English = "en",
  Spanish = "es",
  Estonian = "et",
  Farsi = "fa",
  Finnish = "fi",
  French = "fr",
  Guarani = "gn",
  Gujarati = "gu",
  Hebrew = "he",
  Hindi = "hi",
  Croatian = "hr",
  Hungarian = "hu",
  Indonesia = "id",
  Italian = "it",
  Japanese = "ja",
  Kannada = "kn",
  Korean = "ko",
  Lithuanian = "lt",
  Latvian = "lv",
  Macedonian = "mk",
  Malayalam = "ml",
  Mongolian = "mn",
  Cebuano = "ceb",
  Marathi = "mr",
  Malay = "ms",
  Nepalese = "ne",
  Dutch = "nl",
  Norwegian = "no",
  Punjabi = "pa",
  Polish = "pl",
  Portuguese = "pt",
  Romanian = "ro",
  Russian = "ru",
  Sinhala = "si",
  Slovakian = "sk",
  Slovenian = "sl",
  Somalian = "so",
  Albanian = "sq",
  Serbian = "sr",
  Swedish = "sv",
  Swahili = "sw",
  Tamil = "ta",
  Telugu = "te",
  Thai = "th",
  Tagalog = "tl",
  Turkish = "tr",
  Ukrainian = "uk",
  Urdu = "ur",
  Vietnamese = "vi",
  Chinese = "zh-cn",
  Taiwan = "zh-tw",
  UNKNOWN = "xx",
}

const GRADIENTS = ["#FFCC00", "#FF0000", "#66CC00"];

type LanguagesColors = Record<Language, string>;

const MainColors: Partial<LanguagesColors> = {
  [Language.French]: "#33CCCC",
  [Language.English]: "#6600CC",
  [Language.German]: "#0066FF",
  [Language.Spanish]: "#CC0099",
  [Language.Chinese]: "#00FF99",
};

export function getLanguageColors(languages: Language[] = []) {
  const _gradients = gradients(GRADIENTS, size(languages));
  return reduce(
    languages,
    (acc, language, cpt) => {
      acc[language] = MainColors[language] || _gradients[cpt];
      return acc;
    },
    {} as Partial<LanguagesColors>
  );
}

export function getAllLanguages() {
  return Object.keys(Language)
    .map((k) => Language[k as keyof typeof Language])
    .map((v) => v as Language);
}
